var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-steps',{attrs:{"items":_vm.items,"type":_vm.type,"active-step":_vm.activeStep,"has-navigation":false},on:{"click":_vm.modifyStep}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }